// extracted by mini-css-extract-plugin
module.exports = {"filtersFilter":"styles_filtersFilter__17rL7","expanded":"styles_expanded__33apd"};